var loginFormSelector = '.container.login';
var passwordBlockSelector = '.input-password-group';

$(document).ready(function () {
    if (!$(loginFormSelector).length) {
        return true;
    }

    $(loginFormSelector).on('click', '.submit', function () { loginJson(); });
    initTogglePassword();

    firstTimeMobileNotification();
});

function firstTimeMobileNotification() {
    let mobileDetails = new MobileDetails();

    if(!mobileDetails.isAndroid() || localStorage.getItem('loginPageFirstTimeMobileNotificationShown')){
        return true;
    }

    localStorage.setItem('loginPageFirstTimeMobileNotificationShown', true);

    $('#loginMessageIosStyleModal .modal-title').html('Welcome to webliveview sales app<br>One app for your ecommerce sales support team');
    $('#loginMessageIosStyleModal .modal-body').html('<p>Next easy steps to go live with our app</p><p>1. Create a webliveview account here<br>2. Ask your web developer add your widget js code to your website<br>3. Add your teams login details to your account and download our free app to their mobile phone</p>Enjoy live webchat and video chat conversations with your online website customers for free for 30 days and make some new sales');
    $('#loginMessageIosStyleModal').modal('show');
}

function loginJson() {
    $(loginFormSelector + ' .submit').addClass('disabled');
    let modalSelector = '#publicWarningModal';

    $.post('/login/loginjson', { username: $('input[name="email"].login__input').val(), password: $('input[name="password"].login__input').val(), submit: 'Login', authSide: 'mobile' },
        function (data) {
            $(loginFormSelector + ' .submit').removeClass('disabled');
            data = JSON.parse(data);
            if (!!data.error) {
                $(modalSelector + ' .modal-body').first().html(data.error);
                $(modalSelector + ' .modal-title').html('Attentions');
                $(modalSelector).modal('show');
                $(loginFormSelector + ' .login__error').html(data.error);
                return true;
            }

            if (data.showModal) {
                $(modalSelector + ' .modal-body').first().html(data.modalMessage);
                $(modalSelector + ' .modal-title').html('ID is active on another device');
                $(modalSelector).modal('show');

                window.setTimeout(function () { window.location = '/webchat-mobile'; }, 1500);
                return true;
            }
            window.location = '/webchat-mobile';
        });
}

function initTogglePassword(event) {
    $(passwordBlockSelector + " a").on('click', function (event) {
        event.preventDefault();
        let input = $(this).parent().parent().find('input');
        if (input.attr("type") == "text") {
            input.attr('type', 'password');
            return;
        }

        if (input.attr("type") == "password") {
            input.attr('type', 'text');
        }
    });
}